import axios from "axios";

export default function updateTicketPriority({ id, priority }) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/tickets/${id}/priority`, { priority })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
